class ExperienceTierEnum {
  static JUNIOR = 'junior';
  static INTERMEDIATE = 'intermediate';
  static SENIOR = 'senior';
  static EXPERT = 'expert';

  static labelKey(item: string) {
    return ExperienceTierEnum.meta(item)?.labelKey;
  }

  static meta(item: string) {
    switch (item) {
      case ExperienceTierEnum.JUNIOR:
        return {
          labelKey: 'global.experience_tiers.junior',
        };
      case ExperienceTierEnum.INTERMEDIATE:
        return {
          labelKey: 'global.experience_tiers.intermediate',
        };
      case ExperienceTierEnum.SENIOR:
        return {
          labelKey: 'global.experience_tiers.senior',
        };
      case ExperienceTierEnum.EXPERT:
        return {
          labelKey: 'global.experience_tiers.expert',
        };
    }
  }

  static all() {
    return [
      {
        key: ExperienceTierEnum.JUNIOR,
        labelKey: ExperienceTierEnum.labelKey(ExperienceTierEnum.JUNIOR),
      },
      {
        key: ExperienceTierEnum.INTERMEDIATE,
        labelKey: ExperienceTierEnum.labelKey(ExperienceTierEnum.INTERMEDIATE),
      },
      {
        key: ExperienceTierEnum.SENIOR,
        labelKey: ExperienceTierEnum.labelKey(ExperienceTierEnum.SENIOR),
      },
      {
        key: ExperienceTierEnum.EXPERT,
        labelKey: ExperienceTierEnum.labelKey(ExperienceTierEnum.EXPERT),
      },
    ];
  }
}

export default ExperienceTierEnum;
